import React from 'react';

interface SummaryData {
  totalProduction: number;
  totalDefects: number;
  defectRate: string;
  acceptanceRate?: string;
  kpiSendCount: number;
  lastUpdateTime?: string;
}

interface SummaryCardsProps {
  summaryData: SummaryData;
}

// 요약 카드 설정
export const summaryCards = [
  {
    key: 'totalProduction',
    label: '총 생산량',
    unit: '개',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50'
  },
  {
    key: 'totalDefects',
    label: '총 불량',
    unit: '개',
    color: 'text-red-500',
    bgColor: 'bg-red-50'
  },
  {
    key: 'defectRate',
    label: '불량률',
    unit: '',
    color: 'text-orange-500',
    bgColor: 'bg-orange-50'
  },
  {
    key: 'kpiSendCount',
    label: 'KPI전송량',
    unit: '건',
    color: 'text-green-500',
    bgColor: 'bg-green-50'
  }
];

export const SummaryCards: React.FC<SummaryCardsProps> = ({ summaryData }) => {
  const getValue = (key: string) => {
    switch (key) {
      case 'totalProduction':
        return `${(summaryData.totalProduction || 0).toLocaleString()}개`;
      case 'totalDefects':
        return `${(summaryData.totalDefects || 0).toLocaleString()}개`;
      case 'defectRate':
        return summaryData.defectRate || '0.00%';
      case 'kpiSendCount':
        return `${(summaryData.kpiSendCount || 0).toLocaleString()}건`;
      default:
        return '-';
    }
  };

  return (
    <div className="grid grid-cols-4 gap-4">
      {summaryCards.map((card) => (
        <div key={card.key} className={`bg-white p-4 rounded-lg shadow ${card.bgColor}`}>
          <h3 className="text-sm text-gray-500">{card.label}</h3>
          <p className={`text-2xl font-bold ${card.color}`}>
            {getValue(card.key)}
          </p>
        </div>
      ))}
    </div>
  );
}; 